import React from "react";
import ReactDOM from "react-dom/client";

import PulseLoader from "react-spinners/PulseLoader";
import { SkeletonTheme } from "react-loading-skeleton";

import { getWpRoute } from "../providers/content";

import theme from "../theme.js";

import { Single, Single404 } from "./single";
import Multiple from "./multiple";
import Contact from "./contact";
import Sitemap from "./sitemap";

const PageRoutes = () => {
  const { wpRoute, location } = getWpRoute();

  // Remove trailing slash
  const pathname = location.pathname.replace(/\/$/, "");

  if (wpRoute === undefined) {
    return (
      <div className="d-flex justify-content-center py-5">
        <PulseLoader />
      </div>
    );
  }

  let component = <Single404 />;

  component = wpRoute["is_home"] ? null : component;

  component = wpRoute["is_page"] ? <Single id={wpRoute.posts[0].ID} postType="page" /> : component;
  component = wpRoute["is_single"] ? <Single id={wpRoute.posts[0].ID} postType={wpRoute.query["post_type"] || "post"} /> : component;

  component = wpRoute["is_archive"] ? <Multiple title="Suchergebnisse" wpRoute={wpRoute} /> : component;
  component = wpRoute["is_search"] ? <Multiple title="Suchergebnisse" wpRoute={wpRoute} /> : component;
  component = pathname === "/aktuelles" ? <Multiple title="Aktuelle Beiträge" wpRoute={wpRoute} pagination={false} /> : component;

  component = pathname.startsWith("/event") ? null : component;

  component = pathname === "/sitemap" ? <Sitemap /> : component;

  component = pathname === "/kontakt" ? <Contact /> : component;

  return component;
};

const renderCustomPages = () => {
  const pageRoot = document.getElementById("page-root");


  pageRoot &&
    ReactDOM.createRoot(pageRoot).render(
      <SkeletonTheme color={theme["mebm-light-grey"]}>
        <PageRoutes />
      </SkeletonTheme>
    );
};

export default renderCustomPages;
